import { useMutation } from 'react-query'

import { getGoogleLoginLink } from 'services/endpoints/auth'

export const useGoogleLogin = () => {
    return useMutation(async () => await getGoogleLoginLink())
}
